import React, { useState } from 'react'
import TaskStatusList from './TaskStatusList'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'

function TaskStatus() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<TaskStatusList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default TaskStatus